import React from 'react'
import classNames from 'classnames'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'
import { DeleteIcon, GlobeIcon, PenCrossedIcon } from 'components/Utils/Icons'

type AccessibilityBadgeProps = React.HTMLAttributes<HTMLDivElement> & {
  children?: React.ReactNode
  className?: string
}

const AccessibilityBadge = ({
  children,
  className,
  ...otherProps
}: AccessibilityBadgeProps) => (
  <div
    {...otherProps}
    className={classNames(
      'entity-highlight margin-left-small radius-normal padding-small flexbox flexbox-align-center',
      className
    )}
  >
    {children}
  </div>
)

export type TopBarAccessibilityProps = {
  readOnly: boolean
  isArchived: boolean
  isPublic: boolean
  isChannel: boolean
  onPublicBadgeClick?: React.MouseEventHandler
}

export const TopBarAccessibility = ({
  readOnly,
  isArchived,
  isPublic,
  isChannel,
  onPublicBadgeClick,
}: TopBarAccessibilityProps) => {
  if (!readOnly && !isArchived && !isPublic) {
    return null
  }

  if (isArchived) {
    return (
      <AccessibilityBadge>
        <DeleteIcon className="margin-right-small" size={12} />
        In Trash
      </AccessibilityBadge>
    )
  }

  return (
    <>
      {isPublic && (
        <TooltipOnHover
          id="note-visibility-label"
          placement="bottom"
          delayShow={0}
          tooltipContent={
            isChannel
              ? 'This channel is published on the web'
              : 'Public link enabled'
          }
        >
          <AccessibilityBadge
            className={onPublicBadgeClick ? 'pointer' : ''}
            onClick={onPublicBadgeClick}
          >
            <GlobeIcon className="margin-right-small" size={12} />
            Public
          </AccessibilityBadge>
        </TooltipOnHover>
      )}
      {readOnly && (
        <AccessibilityBadge>
          <PenCrossedIcon className="margin-right-small" size={12} />
          Read only
        </AccessibilityBadge>
      )}
    </>
  )
}
